import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useRequest } from '@Contexts/Request';

import type { ProductData } from '@Types/Product';
import type { IRelatedProducts } from '@Types/RelatedProducts';

const useSingleSelect = (mainId: number) => {
  const queryClient = useQueryClient();
  const { region, country } = useRequest();
  const key = ['related-products', mainId, { country, region }];

  return useMutation({
    mutationKey: key,
    mutationFn: async (data: { product: ProductData; quantity?: number }) => {
      const { product, quantity } = data;

      if (typeof quantity === 'number') {
        return { ...product, quantity };
      }

      return product;
    },
    onSuccess: (newProduct) => {
      queryClient.setQueryData<IRelatedProducts>(key, (data: IRelatedProducts) => {
        const newChangedProducts = data.changedProducts.map((product) =>
          product.id === newProduct.id ? newProduct : { ...product, quantity: 0 },
        );

        return {
          ...data,
          changedProducts: newChangedProducts,
        };
      });
    },
  });
};

export default useSingleSelect;
